import { PROJECT_SUCCESS, PROJECT_FAILURE } from "redux/constants/index";
import { onSuccess, onFailure } from "redux/reducers/common";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initStat, action) => {
  // console.log(action);
  switch (action.type) {

    case PROJECT_SUCCESS:
      return onSuccess(state, action);
    case PROJECT_FAILURE:
      return onFailure(state, action);
 
    default:
      return { ...state };
  }
};
